import React from 'react'

import Text from 'components/_new/typography/Text/Text'

import messages from './messages'


type StepCountProps = {
  step: number
  count: number
}

const StepCount: React.FunctionComponent<StepCountProps> = ({ step, count }) => (
  <Text
    message={{ ...messages.step, values: { step, count } }}
    color="brand"
    size="14-16"
  />
)


export default StepCount
